import "./public.scss";
import "./profile.scss";
import "../admin/models.scss";
